// extracted by mini-css-extract-plugin
module.exports = {"root":"Service_root__30Aln","section":"Service_section__2jo0J","title":"Service_title__2XwGm","content":"Service_content__sTbZo"};